
import { useState } from 'react'

import Divider from './divider'
import ViewMore from './view-more'


import useParticipants from '../hooks/use-participants'
import { Avatar } from "@heroui/react"

const Participants = ({ challenge }) => {
  const page = 56
  const [limit, setLimit] = useState(page)
  
  const participantHook = useParticipants(challenge.id)
  const participants = participantHook.participants

  if (participants.length === 0) return <></>
  
  const list = participants.map(item => {
    const arr = [
      'bg-primary-100',
      'bg-primary-200',
      'bg-primary-300', 
      'bg-primary-400',
      'bg-primary-500',
      'bg-primary-600', 
      'bg-primary-700', 
      'bg-primary-800',
      'bg-primary-900'
    ]
    const randomIndex = Math.floor(Math.random() * arr.length)
    const base = `${arr[randomIndex]} ${randomIndex > 3 ? 'text-white' : 'text-black'}`
    return { ...item, base }
  })
  
  return <>
    <Divider>
      {participants.length} Participant{participants.length > 1 ? 's' : ''}
    </Divider>
    <div className='flex gap-3 items-center flex-wrap mb-4'>
      {list.filter((item, index) => index < limit).map((item, index) => {
        const base = { base: item.base }
        return <Avatar key={index} src={item.photo} showFallback name={item.initials} classNames={base} /> // name is actually iniitals
      })}
    </div>
    <ViewMore pageSize={limit} data={participants} onClick={() => setLimit(limit + page)} text={'View More Participants'} />
  </>
}

export default Participants